import React from 'react';

const InfoIcon = ({
  size = 24,
  color = '#3B3B3B',
  strokeWidth = 2,
  className = '',
  ariaLabel = '',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="23"
      height="22"
      rx="11"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M13.543 6.02783C13.9062 6.02783 14.2109 6.15381 14.457 6.40576C14.709 6.65771 14.835 6.9624 14.835 7.31982C14.835 7.67725 14.709 7.98193 14.457 8.23389C14.2051 8.48584 13.9004 8.61182 13.543 8.61182C13.1914 8.61182 12.8896 8.48584 12.6377 8.23389C12.3857 7.98193 12.2598 7.67725 12.2598 7.31982C12.2598 6.9624 12.3828 6.65771 12.6289 6.40576C12.8809 6.15381 13.1855 6.02783 13.543 6.02783ZM14.0879 10.0708L12.2861 16.3198C12.1865 16.6772 12.1367 16.9116 12.1367 17.0229C12.1367 17.0874 12.1631 17.1489 12.2158 17.2075C12.2686 17.2603 12.3242 17.2866 12.3828 17.2866C12.4824 17.2866 12.582 17.2427 12.6816 17.1548C12.9453 16.938 13.2617 16.5454 13.6309 15.9771L13.9297 16.1528C13.0449 17.6938 12.1045 18.4644 11.1084 18.4644C10.7275 18.4644 10.4229 18.3589 10.1943 18.1479C9.97168 17.9312 9.86035 17.6587 9.86035 17.3306C9.86035 17.1138 9.91016 16.8384 10.0098 16.5044L11.2314 12.3032C11.3486 11.8989 11.4072 11.5942 11.4072 11.3892C11.4072 11.2603 11.3516 11.146 11.2402 11.0464C11.1289 10.9468 10.9766 10.897 10.7832 10.897C10.6953 10.897 10.5898 10.8999 10.4668 10.9058L10.5811 10.5542L13.5605 10.0708H14.0879Z"
      fill={color}
    />
  </svg>
);

export default InfoIcon;
